import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import Chip from '@mui/material/Chip'
import { grey } from '@mui/material/colors'
import React from 'react'

import T from 'T'

import type { PlaceholderKind } from 'types/entities/shared'

type PendingPlacementChipProps = {
  kind?: PlaceholderKind
}

// Dashed neutral, never the status palette: a placement has no status.
const PendingPlacementChip = ({ kind = 'PENDING' }: PendingPlacementChipProps) => {
  const noneExpected = kind === 'NONE_EXPECTED'

  return (
    <Chip
      icon={noneExpected ? <BlockOutlinedIcon /> : <ScheduleOutlinedIcon />}
      label={noneExpected ? T.NO_CONTAINER : T.PENDING_PLACEMENT}
      size="small"
      sx={{
        borderRadius: 2,
        border: '1px dashed',
        borderColor: grey[500],
        color: 'text.secondary',
        bgcolor: 'transparent',
        fontWeight: 500,
        '& .MuiChip-icon': { color: 'text.secondary' },
      }}
      variant="outlined"
    />
  )
}

export default PendingPlacementChip
